import { RouteHelper } from "@app/helpers/route-helper.ts";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_manager")({
    beforeLoad: RouteHelper.AuthGuard,
});
